import '../Styles/TechStack.css';

const TechStack =() => {
  return (
    <section id='techStack' className='techStack-section'>
      <span className='techStack-section-span'></span>
      <li className='techStack-section-list'>
        <ul>Javascript</ul>
        <ul>Typescript</ul>
        <ul>React</ul>
        <ul>Redux</ul>
        <ul>Next</ul>
        <ul>CSS</ul>
        <ul>SCSS</ul>
        <ul>Bootstrap</ul>
        <ul>NodeJs</ul>
        <ul>Docker</ul>
        <ul>MongoDB</ul>
        <ul>PostgreSQL</ul>
        <ul>AW</ul>
      </li>
    </section>
  )
}

export default TechStack